/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查看票张
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  orderDetailSeatDto: order.OrderDetailSeatDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.OrderDetailSeatTicket;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/view-ticket`,
    data: orderDetailSeatDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
